/*eslint-disable */

import { bus } from '@/main';
import toast from '@/services/toast';
import twoFactorDataPopup from '@/components/private/dataset/two-factor-for-data-popup/';

export default {
  name: 'shared-data-list',
  components: {
    'two-factor-data' : twoFactorDataPopup
  },
  props: ['catStatePROP'],
  data () {
    return {
      sharedDatasetList:null,
      sharedDatasetListResults:[],
      submitted:false,
      apiResLoader:false,
      twoFactorVerifedPopup:false,
      twoFactorDataId:'',
      title:'',
      userAuthorizedPopupState:false
    }
  },
  computed: {

  },
  mounted () {
    bus.$on('twoFactorVerifedPopupBus', (data) => {
      this.twoFactorVerifedPopup = data;
    });
    this.getsharedDatasetListMethod();
  },
  methods: {
    twoFactorVerifedPopupOpenMethod(ID){
      this.$store.dispatch('sendTwoFactorOtp', {id:ID}).then((res) => {
        toast.success(res.data.user_msg);
        this.twoFactorVerifedPopup = true
        this.twoFactorDataId = 
        document.body.classList.add('body_right_scroll_remove');
      })
    },
    getsharedDatasetListMethod(){     
      if(this.catStatePROP == 'outgoing'){
        this.$store.dispatch('outgoingSharedDatasetListAction').then((res) => {
          this.sharedDatasetList = res.data
          this.sharedDatasetListResults = this.sharedDatasetList.data
        })
      }else{
        this.$store.dispatch('icomingSharedDatasetListAction').then((res) => {
          this.sharedDatasetList = res.data
          this.sharedDatasetListResults = this.sharedDatasetList.data
        })
      }
    },
    searchAlgoDataMethod(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          if(this.title.length > 2){
            this.submitted = true
            let data = {
              search : this.title
            }        
            this.$store.dispatch('searchAlgoDataAction', data).then((res) => {
              this.sharedDatasetList = res.data.data
              this.sharedDatasetListResults = this.sharedDatasetList.results
              this.submitted = false
            }).catch((err) => {
              this.submitted = false
            })
          }else if(this.title.length == 0){
            this.getsharedDatasetListMethod();
          }
        }
      })
    },
    userAuthriozedNotDownLoadDataMethod(){
      document.body.classList.add('body_right_scroll_remove');
      this.userAuthorizedPopupState = true
    },
    userAuthorizedPopupMethod(){
      document.body.classList.remove('body_right_scroll_remove')
      this.userAuthorizedPopupState = false
    },
    downloadFileMethod(file,fileName){
      var link = document.createElement('a');
      link.href = file
      link.download =  fileName;
      document.body.appendChild(link);
      link.click();
    },
    selectedAlgoDataDetailsByIdMethod(dataId){
      this.$store.dispatch('getAllPubAlgoDataListByIdAction',{id:dataId}).then((res)=>{
        this.downloadFileMethod(res.data.data.data_file,res.data.data.data_file_name)
      }).catch((err)=>{

      })
    },
  }
}